export const QUERY_KEYS = {
  ALBUM: "album",
  ALBUMS: "albums",
  IMAGE: "image",
};
